interface Props {
  disabled: boolean;
}

const SvgPlus: React.FC<Props> = ({ disabled }) => {
  return (
    <svg
      style={{ cursor: disabled ? "not-allowed" : "pointer" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15683_9145)">
        <path
          d="M5.98828 1.18905C5.77625 1.19216 5.57412 1.27932 5.42631 1.43137C5.2785 1.58343 5.1971 1.78795 5.2 1.99999V5.19999H2C1.89399 5.19849 1.78874 5.21807 1.69037 5.25761C1.59199 5.29714 1.50245 5.35582 1.42696 5.43026C1.35146 5.5047 1.29151 5.59339 1.2506 5.6912C1.20968 5.78901 1.18861 5.89397 1.18861 5.99999C1.18861 6.10601 1.20968 6.21097 1.2506 6.30878C1.29151 6.40658 1.35146 6.49528 1.42696 6.56972C1.50245 6.64415 1.59199 6.70284 1.69037 6.74237C1.78874 6.7819 1.89399 6.80149 2 6.79999H5.2V9.99999C5.1985 10.106 5.21809 10.2112 5.25762 10.3096C5.29715 10.408 5.35584 10.4975 5.43027 10.573C5.50471 10.6485 5.59341 10.7085 5.69121 10.7494C5.78902 10.7903 5.89398 10.8114 6 10.8114C6.10602 10.8114 6.21098 10.7903 6.30879 10.7494C6.40659 10.7085 6.49529 10.6485 6.56973 10.573C6.64416 10.4975 6.70285 10.408 6.74238 10.3096C6.78192 10.2112 6.8015 10.106 6.8 9.99999V6.79999H10C10.106 6.80149 10.2113 6.7819 10.3096 6.74237C10.408 6.70284 10.4975 6.64415 10.573 6.56972C10.6485 6.49528 10.7085 6.40658 10.7494 6.30878C10.7903 6.21097 10.8114 6.10601 10.8114 5.99999C10.8114 5.89397 10.7903 5.78901 10.7494 5.6912C10.7085 5.59339 10.6485 5.5047 10.573 5.43026C10.4975 5.35582 10.408 5.29714 10.3096 5.25761C10.2113 5.21807 10.106 5.19849 10 5.19999H6.8V1.99999C6.80146 1.89302 6.78146 1.78685 6.74118 1.68775C6.70089 1.58865 6.64114 1.49864 6.56546 1.42303C6.48979 1.34742 6.39971 1.28776 6.30057 1.24757C6.20144 1.20738 6.09524 1.18748 5.98828 1.18905Z"
          className={`${disabled ? "fill-gray3" : "fill-current"}`}
        />
      </g>
      <defs>
        <clipPath id="clip0_15683_9145">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgPlus;
